import { Flex, Text } from "@chakra-ui/react";
import {
  defaultDurationState,
  startOfWeekState,
  timeFormatState,
} from "../../../../recoil/calendar/settingCalendar";
import { visibilityState } from "../../../../recoil/calendar/settingCalendarV2";
import {
  DefaultDurationOption,
  OptionType,
  StartOfWeekOption,
  TimeFormatOption,
  VisibilityOption,
} from "../../../../types/settings/enum";
import useToggle from "../../../../utils/settings/useToggle";
import ToggleSwitch from "./ToggleSwitch";

// NOT 해당 부분에서만 사용되는 interface라 내부에 선언했습니다.
interface SettingItem {
  title: string;
  options: OptionType[];
  value: OptionType;
  toggle: (option: OptionType) => void;
}

const Preferences: React.FC = () => {
  const [startOfWeek, toggleStartOfWeek] = useToggle(startOfWeekState);
  const [timeFormat, toggleTimeFormat] = useToggle(timeFormatState);
  const [defaultDuration, toggleDefaultDuration] = useToggle(defaultDurationState);
  const [visibility, toggleVisibility] = useToggle(visibilityState);

  const settings: SettingItem[] = [
    {
      title: "Start of week",
      options: [StartOfWeekOption.SUNDAY, StartOfWeekOption.MONDAY],
      value: startOfWeek,
      toggle: toggleStartOfWeek,
    },
    {
      title: "Time format",
      options: [TimeFormatOption.HOUR12, TimeFormatOption.HOUR24],
      value: timeFormat,
      toggle: toggleTimeFormat,
    },
    {
      title: "Default duration",
      options: [
        DefaultDurationOption.MIN15,
        DefaultDurationOption.MIN30,
        DefaultDurationOption.MIN60,
      ],
      value: defaultDuration,
      toggle: toggleDefaultDuration,
    },
    {
      title: "Visibility",
      options: [VisibilityOption.PUBLIC, VisibilityOption.DEEPWORK, VisibilityOption.INVISIBLE],
      value: visibility,
      toggle: toggleVisibility,
    },
  ];

  return (
    <Flex
      direction="column"
      justify="stretch"
      w="100%"
      h="100%"
      flexGrow={1}
      maxW="650px"
      px="30px"
      gap="30px"
    >
      <Text
        color="white"
        fontSize="16px"
        fontWeight="500"
        lineHeight="150%"
        userSelect={"none"}
      >
        Preferences
      </Text>
      <Flex
        direction="column"
        h="max-content"
        borderTop="1px solid rgba(255, 255, 255, 0.08)"
        alignSelf="stretch"
      >
        {settings.map((item) => (
          <ToggleSwitch
            key={item.title}
            title={item.title}
            options={item.options}
            selectedOption={item.value}
            onOptionChange={item.toggle}
          />
        ))}
      </Flex>
    </Flex>
  );
};

export default Preferences;
